<template>
  <div>
    <Widget>
      <b-row>
        <b-col>
          <h3>Patient: <b>{{ patientcheckup.patient.name }}</b></h3>
        </b-col>

      </b-row>
      <hr>
      <hr>
      <span class="mb-2"><h5>Amount : {{ patientcheckup.amount }}</h5></span>
      <span class="mb-2"><h5>Status : {{ ['pending', 'finished'][patientcheckup.patientcheckup.status] }}</h5></span>
      <span class="mb-2"><h5>Start Time : {{ patientcheckup.patientcheckup.start_time }}</h5></span>
      <span class="mb-2"><h5>End Time : {{ patientcheckup.patientcheckup.end_time }}</h5></span>
      <span class="mb-2"><h5 class="text-center">Call Logs :</h5> <b-badge variant="light" v-for="calllog in JSON.parse(patientcheckup.patientcheckup.call_log)" :key="calllog">
          {{ calllog }}
        </b-badge>
      </span>
    </Widget>


  </div>

</template>

<script>
export default {
  name: "CheckupDetailsModal",
  props: ['patientcheckup'],
  mounted() {
  }
}
</script>

<style scoped>

</style>
